// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_containerTitle__vjfph{
    align-items: center;
    display: flex;
    justify-content: space-between;
}

.styles_title__nh-IU{
    align-items: center;
    display: flex;
    font-size: 1.5rem;
    font-weight: bold;
    gap: .7rem;
    justify-content: flex-start;
}

.styles_containerBtn__H37y8{
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
}

.styles_btnClose__s2z\\+a{
    border-color: #18316e !important;
    color: #18316e !important;
    &:hover{
        border-color: #18316e !important;
    }
}

.styles_containerAccordion__lRbje{
    margin-top: 1rem;
}

.styles_detailAccordion__rKX4a{
    border-radius: 5px;
    box-shadow: 1px 1px 2px #C9C9C9;
    padding: .4rem;
}

.styles_detailAccordionHeader__Z2uwZ{
    align-items: center;
    display: flex;
    justify-content: space-between;
}

.styles_titleObs__\\+d8n6{
    align-items: center !important;
    color: #18316e !important;
    display: flex !important;
    gap: .2rem !important;
}

.styles_containerBtnObs__vRfKI{
    align-items: center;
    display: flex;
    margin-top: 1rem;
    justify-content: space-between;
}

.styles_btnSend__5OP1p{
    background: #18316e !important;
    &:hover{
        background: #203e8b !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Juridico/ModalAnaliseSimples/styles.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B;QACI,8BAA8B;IAClC;AACJ","sourcesContent":[".containerTitle{\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n}\n\n.title{\n    align-items: center;\n    display: flex;\n    font-size: 1.5rem;\n    font-weight: bold;\n    gap: .7rem;\n    justify-content: flex-start;\n}\n\n.containerBtn{\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 1rem;\n}\n\n.btnClose{\n    border-color: #18316e !important;\n    color: #18316e !important;\n    &:hover{\n        border-color: #18316e !important;\n    }\n}\n\n.containerAccordion{\n    margin-top: 1rem;\n}\n\n.detailAccordion{\n    border-radius: 5px;\n    box-shadow: 1px 1px 2px #C9C9C9;\n    padding: .4rem;\n}\n\n.detailAccordionHeader{\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n}\n\n.titleObs{\n    align-items: center !important;\n    color: #18316e !important;\n    display: flex !important;\n    gap: .2rem !important;\n}\n\n.containerBtnObs{\n    align-items: center;\n    display: flex;\n    margin-top: 1rem;\n    justify-content: space-between;\n}\n\n.btnSend{\n    background: #18316e !important;\n    &:hover{\n        background: #203e8b !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerTitle": `styles_containerTitle__vjfph`,
	"title": `styles_title__nh-IU`,
	"containerBtn": `styles_containerBtn__H37y8`,
	"btnClose": `styles_btnClose__s2z+a`,
	"containerAccordion": `styles_containerAccordion__lRbje`,
	"detailAccordion": `styles_detailAccordion__rKX4a`,
	"detailAccordionHeader": `styles_detailAccordionHeader__Z2uwZ`,
	"titleObs": `styles_titleObs__+d8n6`,
	"containerBtnObs": `styles_containerBtnObs__vRfKI`,
	"btnSend": `styles_btnSend__5OP1p`
};
export default ___CSS_LOADER_EXPORT___;
